import * as angular from 'angular';
import { States } from "../../shared/config/constant.module";
import template from './TiamaDefectMappings.tpl.html';
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import TiamaDefectMappingServiceName, { TiamaDefectMappingService } from "../../services/defects/tiamaDefectMapping.service";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import EditTiamaDefectMappingName, { openEditTiamaDefectMapping } from "./editTiamaDefectMapping.controller";
import AddTiamaDefectMappingName, { openAddTiamaDefectMapping } from "./addTiamaDefectMapping.controller";
import * as _ from 'lodash';

let requires = [LoaderServiceName, TiamaDefectMappingServiceName, EditTiamaDefectMappingName, AddTiamaDefectMappingName];

interface ViewDefectTypesController {
  tiamaDefectMappings: apsViewModels.TiamaDefectMappingItem[];
  addTiamaDefectMapping(): void;
  displayTiamaDefectMappings(): void;
  editTiamaDefect(tiamaDefectId: string): void;
}

export default angular.module('aps.controller.tiamaDefectMappings', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.VIEW_TIAMA_DEFECT_MAPPINGS,
      url: '/tiamaDefectMappings',
      controller: 'tiamaDefectMappingsCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Tiama Defect Mappings'
      }
    });
  })
  .controller('tiamaDefectMappingsCtrl', tiamaDefectMappingsCtrl)
  .name;

function tiamaDefectMappingsCtrl(
  $modal: mm.foundation.modal,
  loaderService: LoaderService,
  tiamaDefectMappingService: TiamaDefectMappingService
): ViewDefectTypesController {
  let vm = {} as ViewDefectTypesController;

  vm.displayTiamaDefectMappings = function () {
    loaderService.loadingPromise(tiamaDefectMappingService
      .getTiamaDefectMappings().then(data => {
        vm.tiamaDefectMappings = data;
      }));
    return;
  };

  vm.editTiamaDefect = function (tiamaDefectId: string) {
    let result = openEditTiamaDefectMapping({
      tiamaDefectId: tiamaDefectId
    }, $modal);

    result.then(function (data) {
      if ((data || '') !== '') {
        if ((data.action || '') !== '') {
          switch (data.action) {
            case 'return':
              updateEditedTiamaDefect(data.tiamaDefectMapping);
              break;
            default:
              break;
          }
        }
      }
    });
  };

  vm.addTiamaDefectMapping = function () {
    var result = openAddTiamaDefectMapping($modal);

    result.then(function (data) {
      if ((data || '') !== '') {
        var item = {} as apsViewModels.TiamaDefectMappingItem;

        item.id = data.tiamaDefectMapping.id;
        item.machineType = data.tiamaDefectMapping.machineType;
        item.sensor = data.tiamaDefectMapping.sensor;
        item.counter = data.tiamaDefectMapping.counter;
        item.defectTypeId = data.tiamaDefectMapping.defectTypeId;
        item.defectTypeName = data.tiamaDefectMapping.defectTypeName;

        vm.tiamaDefectMappings.push(item);
      }
    });
  };

  var updateEditedTiamaDefect = function (tiamaDefectMapping) {
    if ((tiamaDefectMapping || '') !== '') {
      var tiamaDefectMappingUpdated = _.find(vm.tiamaDefectMappings,
        function (item: any) {
          return item.id === tiamaDefectMapping.id;
        });
      if ((tiamaDefectMappingUpdated || '') !== '') {

        tiamaDefectMappingUpdated.id = tiamaDefectMapping.id;
        tiamaDefectMappingUpdated.machineType = tiamaDefectMapping.machineType;
        tiamaDefectMappingUpdated.sensor = tiamaDefectMapping.sensor;
        tiamaDefectMappingUpdated.counter = tiamaDefectMapping.counter;
        tiamaDefectMappingUpdated.defectTypeId = tiamaDefectMapping.defectTypeId;
        tiamaDefectMappingUpdated.defectTypeName = tiamaDefectMapping.defectTypeName;
      }
    }
  };

  vm.displayTiamaDefectMappings();

  return vm;
}


// WEBPACK FOOTER //
// ./src/app/controllers/tiamaDefectMappings/tiamaDefectMappings.controller.ts